// src/navigationSlice.js
import { createSlice } from '@reduxjs/toolkit';


const initialState = {
  showFilter: false,
  addButton: false,
  buttonText: "New",
  buttonFunction: ()=>{

  },
  secondaryButton: false,
  secondaryButtonText: "New",
  secondaryButtonFunction: ()=>{

  },
  sequenceButton: false,
  sequenceButtonProps: null
};

const pageHeaderSlice = createSlice({
  name: 'pageHeader',
  initialState,
  reducers: {
    updatepageHeader: (state, action) => {
        return { ...state, ...action.payload };
    },
    resetpageHeader: (state, action) => {
        
        return initialState; // Reset to initial stat
    }
  },
});

export const { updatepageHeader, resetpageHeader } = pageHeaderSlice.actions;

export default pageHeaderSlice.reducer;
